import { render, staticRenderFns } from "./SuusTextField.vue?vue&type=template&id=5bd9a9b3"
import script from "./SuusTextField.vue?vue&type=script&lang=ts"
export * from "./SuusTextField.vue?vue&type=script&lang=ts"
import style0 from "./SuusTextField.vue?vue&type=style&index=0&id=5bd9a9b3&prod&lang=sass"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports